/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { getProtectionPlans } from 'src/lib/api-client/protection-plans';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { format, parse } from 'date-fns';
import eventMetricsMap from 'src/hooks/useEventsReporter/event-types';
import useEventsReporter from 'src/hooks/useEventsReporter';
import { useHistory } from 'react-router-dom';
import { openInNewTab } from 'src/lib/utils/nav-utils';
import { useTabsUIStateContext } from 'src/lib/contexts/tabs-ui-state-context';
import { useStoreData } from 'src/hooks';
import { Store } from 'src/services/types';
import Carousel from '../Carousel';
import COLORS from '../../lib/colors';
import FullWidthCard from '../cards/full-width-card';
import AppLink from '../link';
import ROUTES from '../../lib/routes';
import StoreDetailsDrawer from '../store-details-drawer';
import { IconLiveChat } from '../Icons';
import { Body, Heading } from '../UI';

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        display: 'flex',
        userSelect: 'none',
        position: 'relative',
    },
    contaniner: {
        padding: '15px',
        color: COLORS.textBlack,
        [theme.breakpoints.down(390)]: {
            padding: '15px',
        },
        userSelect: 'none',
    },
    description: {
        marginLeft: '10px',
        marginBottom: '10px',
    },
    skuImage: {
        height: '100px',
        width: 'auto',
        [theme.breakpoints.down(410)]: {
            height: '100px',
        },
    },
    title: {
        marginBottom: '5px',
    },
    transaction: {
        marginTop: '15px',
    },
    storeInfo: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    store: {
        color: '#086DD2',
        fontSize: '14px',
        fontFamily: 'StaplesNormsMedium',
        display: 'flex',
        alignItems: 'center',
    },

    actions: {
        color: COLORS.brandCyan,
        fontSize: '14px',
        display: 'flex',
        marginTop: '15px',
        gap: '20px',
    },

    action: {
        color: COLORS.brandCyan,
        fontSize: '14px',
        fontWeight: 600,
        '&:hover': {
            textDecoration: 'none',
        },
    },

    cardFooter: {
        display: 'flex',
        gap: '15px',
        borderTop: '1px solid #f2f2f2',
        padding: '10px 20px',
        alignItems: 'center',
    },

    reg: {
        fontSize: '12px',
    },
    expired: {
        color: COLORS.brandRed,
    },
    fileStatus: {
        fontSize: '16px',
        fontWeight: 500,
    },
    footerLink: {
        '&:hover': {
            textDecoration: 'none',
        },
    },
    learnMore: {
        height: '2.5rem',
        borderRadius: '1.885rem',
        border: '1px solid',
        background: COLORS.homeBlack,
        color: COLORS.primaryWhite,
        textTransform: 'none',
        fontSize: '14px',
        display: 'flex',
        alignSelf: 'flex-start',
        padding: '10px 20px',
        fontFamily: 'StaplesNormsRegular',
        fontWeight: 500,
        margin: '10px 0 0 0px',
    },
    protectionContainer: {
        marginLeft: '16px',
        marginRight: '16px',
        marginBottom: '20px',
    },
    emptyState: {
        marginBottom: '20px',
        marginLeft: '16px',
        marginRight: '16px',
    },

    protectionPlanWrapper: {
        marginBottom: '20px',
    },
    expiredTag: {
        background: '#0058d8',
        color: COLORS.primaryWhite,
        position: 'absolute',
        top: '-10px',
        left: '-5px',
        padding: '2px 10px',
        borderRadius: '15px',
        display: 'inline-block',
        fontSize: '10px',
    },
}));
export function ProtectionPlans() {
    const classes = useStyles();
    const { setStoreLinkInNative } = useTabsUIStateContext();
    const [isLoading, setLoading] = useState(false);
    const [protectionPlanData, setProtectionPlanData] = useState([]);
    const { analyticsCustomEvent } = useEventsReporter();
    const { push: goto } = useHistory();
    const asurionUrl = 'https://protection.asurion.com/protection-plan/en-us/';
    const staplesProtection = `${process.env.REACT_APP_DOTCOM_URL}/stores/tech/pcsupport`;
    const { mainStore, additionalStores, updateMainStore } = useStoreData();
    const [storeDetailsModalOpen, setStoreDetailsModalOpen] = useState(false);

    const onStoreSelected = (store: Store) => {
        updateMainStore(store);
        // setSearchModalOpen(false);
    };
    const getProtectionPlansData = async () => {
        setLoading(true);
        const response: any = await getProtectionPlans();
        if (response.length) {
            setProtectionPlanData(response);
        }
        setLoading(false);
    };
    useEffect(() => {
        getProtectionPlansData();
    }, []);
    const viewReceipt = () => {
        goto(ROUTES.previousOrders);
    };
    const navigateToStore = (storeactive: boolean) => {
        if (storeactive) {
            setStoreDetailsModalOpen(true);
        }
    };
    const formatTransactionNumber = (traId: string) => {
        if (!traId) {
            return '';
        }
        const splitData = traId?.split('.');
        const storeNumber = `0000${splitData[1]}`.slice(-4);
        const parseDate = parse(splitData[2], 'yyyyMMdd', new Date());
        const date = format(parseDate, 'MMddyy');
        const transactionNumber = `00000${splitData[4]}`.slice(-5);
        const rgisterNumber = `00${splitData[3]}`.slice(-2);
        return `${storeNumber}-${date}-${transactionNumber}-${rgisterNumber}`;
    };

    if (isLoading) {
        return null;
    }

    return (
        <div
            className={
                protectionPlanData?.length ? classes.protectionPlanWrapper : ''
            }
        >
            {protectionPlanData?.length ? (
                <>
                    <Carousel
                        animateHeight={false}
                        activeColor={COLORS.brandRed}
                        content={protectionPlanData?.map(
                            ({
                                status,
                                skudescription,
                                subscriptionstartdate,
                                subscriptionsenddate,
                                posid,
                                ereceipttransactionnumber,
                                storenumber,
                                storecity,
                                storestate,
                                storezipcode,
                                skuimageurl,
                                storeactive,
                            }: any) => (
                                <FullWidthCard
                                    noPadding
                                    id="protection-plans-container"
                                    className={classes.protectionContainer}
                                >
                                    <div className={classes.contaniner}>
                                        <div className={classes.cardHeader}>
                                            {status !== 'Active' && (
                                                <strong
                                                    aria-hidden="true"
                                                    className={
                                                        classes.expiredTag
                                                    }
                                                >
                                                    EXPIRED
                                                </strong>
                                            )}
                                            {skuimageurl ? (
                                                <img
                                                    className={classes.skuImage}
                                                    src={skuimageurl}
                                                    alt="protection plan"
                                                />
                                            ) : (
                                                <img
                                                    className={classes.skuImage}
                                                    src={require('../../assets/icons/iconAsurion.svg')}
                                                    alt="protection plan"
                                                />
                                            )}
                                            <Box>
                                                <div
                                                    className={
                                                        classes.description
                                                    }
                                                >
                                                    <Heading
                                                        weight="bold"
                                                        type="h3"
                                                        size={12}
                                                        className={
                                                            classes.title
                                                        }
                                                    >
                                                        Staples
                                                        <sup
                                                            className={
                                                                classes.reg
                                                            }
                                                        >
                                                            &reg;
                                                        </sup>{' '}
                                                        Total Support Plan
                                                    </Heading>
                                                    <Heading
                                                        type="h3"
                                                        className={
                                                            classes.title
                                                        }
                                                    >
                                                        {skudescription}
                                                    </Heading>
                                                    <Body
                                                        weight="light"
                                                        color="textMediumGray"
                                                        size={12}
                                                        margin="-5px 0 0 0"
                                                    >
                                                        powered by Asurion
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                        >
                                                            <span
                                                                aria-label={
                                                                    status ===
                                                                    'Active'
                                                                        ? 'Expires on'
                                                                        : 'Expired on'
                                                                }
                                                                style={{
                                                                    display:
                                                                        'inline-block',
                                                                }}
                                                            >
                                                                Exp &nbsp;
                                                            </span>
                                                            {format(
                                                                new Date(
                                                                    subscriptionsenddate
                                                                ),
                                                                'MM/dd/yyyy'
                                                            )}
                                                        </div>
                                                    </Body>
                                                </div>
                                            </Box>
                                        </div>
                                        <Body
                                            className={classes.transaction}
                                            weight="light"
                                        >
                                            Transaction # :
                                            <strong>
                                                {' '}
                                                {formatTransactionNumber(posid)}
                                            </strong>
                                        </Body>
                                        <Body
                                            weight="light"
                                            color="textMediumGray"
                                            size={12}
                                        >
                                            Purchased on &nbsp;
                                            {format(
                                                new Date(subscriptionstartdate),
                                                'MM/dd/yyyy'
                                            )}
                                        </Body>
                                        {storenumber &&
                                        storecity &&
                                        storestate &&
                                        storezipcode ? (
                                            <div className={classes.storeInfo}>
                                                {!storeactive && (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '5px',
                                                        }}
                                                    >
                                                        <s
                                                            style={{
                                                                color: '#585858',
                                                                fontFamily:
                                                                    'StaplesNormsRegular',
                                                            }}
                                                        >
                                                            {storecity},{' '}
                                                            {storestate}{' '}
                                                            {storezipcode}
                                                        </s>
                                                        <Body
                                                            size={14}
                                                            color="textRed"
                                                        >
                                                            Permanently closed
                                                        </Body>
                                                    </div>
                                                )}
                                                <ButtonBase
                                                    className={classes.store}
                                                    onClick={() =>
                                                        navigateToStore(
                                                            storeactive
                                                        )
                                                    }
                                                >
                                                    {storeactive && (
                                                        <>
                                                            Staples Store #
                                                            {storenumber}{' '}
                                                        </>
                                                    )}
                                                </ButtonBase>
                                                {storeactive ? (
                                                    <Body
                                                        weight="light"
                                                        size={12}
                                                    >
                                                        {storecity},{' '}
                                                        {storestate}{' '}
                                                        {storezipcode}
                                                    </Body>
                                                ) : null}
                                            </div>
                                        ) : null}

                                        <div className={classes.actions}>
                                            {status === 'Active' && (
                                                <ButtonBase
                                                    className={
                                                        classes.learnMore
                                                    }
                                                    style={{ marginTop: '0px' }}
                                                    onClick={() => {
                                                        openInNewTab(
                                                            asurionUrl
                                                        );
                                                        analyticsCustomEvent(
                                                            eventMetricsMap.stores,
                                                            {
                                                                click_text:
                                                                    'file a claim',
                                                                element_location:
                                                                    'promotion tiles',
                                                                tile_category:
                                                                    'asurian carousel',
                                                            }
                                                        );
                                                    }}
                                                >
                                                    File a claim
                                                </ButtonBase>
                                            )}
                                            <ButtonBase
                                                onClick={() => {
                                                    viewReceipt();
                                                    analyticsCustomEvent(
                                                        eventMetricsMap.stores,
                                                        {
                                                            click_text:
                                                                'view receipt',
                                                            element_location:
                                                                'promotion tiles',
                                                            tile_category:
                                                                'asurian carousel',
                                                        }
                                                    );
                                                }}
                                                className={classes.action}
                                            >
                                                View Receipt
                                            </ButtonBase>
                                        </div>
                                    </div>
                                    <AppLink
                                        href="tel:8447287854"
                                        className={classes.footerLink}
                                    >
                                        <div className={classes.cardFooter}>
                                            <IconLiveChat />
                                            <Box>
                                                <Body
                                                    weight="light"
                                                    color="textBlack"
                                                >
                                                    Protection and Tech Help
                                                    questions?
                                                </Body>
                                                <Body
                                                    weight="light"
                                                    color="textLinkBlue"
                                                >
                                                    Chat with Asurion
                                                </Body>
                                            </Box>
                                        </div>
                                    </AppLink>
                                </FullWidthCard>
                            )
                        )}
                        dots={protectionPlanData.length}
                        styles={{
                            containerStyle: {
                                width: '100%',
                            },
                        }}
                    />
                    {storeDetailsModalOpen ? (
                        <StoreDetailsDrawer
                            mainStore={mainStore}
                            nearbyStores={additionalStores}
                            onStoreSelected={onStoreSelected}
                            open={storeDetailsModalOpen}
                            ignoreIsActiveScreen
                            handleClose={() => setStoreDetailsModalOpen(false)}
                        />
                    ) : null}
                </>
            ) : (
                // Empty State for Protection Plans
                <FullWidthCard
                    noPadding
                    id="protection-plans-container"
                    className={classes.emptyState}
                >
                    <div className={classes.contaniner}>
                        <div
                            className={classes.cardHeader}
                            style={{ flexDirection: 'column' }}
                        >
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <img
                                    aria-hidden="true"
                                    style={{ marginTop: '5px' }}
                                    className={classes.skuImage}
                                    src={require('../../assets/icons/iconAsurion.svg')}
                                    alt="protection plan"
                                />
                                <Box>
                                    <div className={classes.description}>
                                        <Heading
                                            type="h3"
                                            size={18}
                                            className={classes.title}
                                        >
                                            Staples
                                            <sup className={classes.reg}>
                                                &reg;
                                            </sup>{' '}
                                            Total Support Plan
                                        </Heading>
                                        <Body
                                            weight="light"
                                            size={14}
                                            color="textBlack"
                                        >
                                            Protection for you and your <br />
                                            computer, starting at <br /> only
                                            $229.99.
                                        </Body>
                                    </div>
                                </Box>
                            </div>
                            <ButtonBase
                                className={classes.learnMore}
                                onClick={() => {
                                    setStoreLinkInNative({
                                        src: staplesProtection,
                                        show: true,
                                    });
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth',
                                    });
                                    analyticsCustomEvent(
                                        eventMetricsMap.stores,
                                        {
                                            click_text: 'learn more',
                                            element_location: 'promotion tiles',
                                            tile_category: 'asurian carousel',
                                        }
                                    );
                                }}
                            >
                                Learn more
                            </ButtonBase>
                        </div>
                    </div>
                </FullWidthCard>
            )}
        </div>
    );
}

export default ProtectionPlans;
